﻿export interface IContactOverridePrimaryAddress {
    street: string;
    city: string;
    state: string;
    postalCode: string;
}
